import { render, staticRenderFns } from "./ExpedicaoBloqueioModal.vue?vue&type=template&id=dcb3bb14&scoped=true"
import script from "./ExpedicaoBloqueioModal.vue?vue&type=script&lang=js"
export * from "./ExpedicaoBloqueioModal.vue?vue&type=script&lang=js"
import style0 from "./ExpedicaoBloqueioModal.vue?vue&type=style&index=0&id=dcb3bb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb3bb14",
  null
  
)

export default component.exports